module.exports = __webpack_public_path__ + "static/media/whatsapp_guide_mobile_05.8692d535.png";